import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f012e658&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f012e658&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f012e658",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsCarouselCategories: require('/web/components/objects/CarouselCategories.vue').default,MainInteresting: require('/web/components/MainInteresting.vue').default,MainFacts: require('/web/components/MainFacts.vue').default,MainAbout: require('/web/components/MainAbout.vue').default,MainExperts: require('/web/components/MainExperts.vue').default,MainQuotes: require('/web/components/MainQuotes.vue').default,MainArts: require('/web/components/MainArts.vue').default,MainObjects: require('/web/components/MainObjects.vue').default,MainEncyclopediaCategories: require('/web/components/MainEncyclopediaCategories.vue').default})
